import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { colors } from '@chillout/core'

interface StampProgressProps {
  current: number
  total: number
  countText?: string
  subtitleText?: string
  showCount?: boolean
  variant?: 'light' | 'dark'
}

export function StampProgress({
  current,
  total,
  countText,
  subtitleText,
  showCount = true,
  variant = 'light',
}: StampProgressProps) {
  const { t } = useTranslation()
  const isDark = variant === 'dark'
  const percentage = total > 0 ? Math.min((current / total) * 100, 100) : 0
  const trackColor = isDark ? colors.stamp.emptyDark : colors.border
  const displayText = countText ?? t('common.stampCount', { current, total })

  return (
    <View className={isDark ? 'gap-2' : 'gap-1'}>
      {showCount ? (
        <View>
          <Text className={isDark ? 'text-2xl font-bold text-inverse' : 'text-sm font-normal text-primary'}>
            {displayText}
          </Text>
          {subtitleText ? (
            <Text className={isDark ? 'text-sm font-normal text-muted' : 'text-xs font-normal text-secondary'}>
              {subtitleText}
            </Text>
          ) : null}
        </View>
      ) : null}
      <View
        className="h-1.5 overflow-hidden rounded-full"
        style={{ backgroundColor: trackColor }}
      >
        <View
          className="h-full rounded-full bg-stamp-filled"
          style={{ width: `${percentage}%` }}
        />
      </View>
    </View>
  )
}